module.exports = __webpack_public_path__ + "static/fonts/BMEuljirooraeoraeOTF.otf?17c8c27e";